<template>
  <div class="min-h-screen relative font-sans">
    <BtnContact />
    <div class="relative z-10">
      <AppHeader />
    </div>
    <main class="relative min-h-[calc(100vh-250px)] z-0 bg-accentLight">
      <slot />
    </main>
    <!-- <AppFooter /> -->
    <AppFooterRevamp />
  </div>
</template>
